import { render } from "./ticketDetail.vue?vue&type=template&id=06c57763"
import script from "./ticketDetail.vue?vue&type=script&lang=js"
export * from "./ticketDetail.vue?vue&type=script&lang=js"

import "./ticketDetail.vue?vue&type=style&index=0&id=06c57763&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__